// Filter-bar.js

$('[data-advanced-filters]').on('click', function(){
    $(this).parents('.section--filter-bar').toggleClass('section--filter-bar--active');
    $(this).toggleClass('active');
});